import { Component } from '@angular/core';
import { MatToolbar } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { OfficineSelectorComponent } from '../shared/components/officine-selector/officine-selector.component';
import { FilialeSelectorComponent } from '../shared/components/filiale-selector/filiale-selector.component';

@Component({
  selector: 'app-gestion-autorisations',
  standalone: true,
  imports: [MatToolbar,RouterModule,OfficineSelectorComponent,FilialeSelectorComponent],
  templateUrl: './gestion-autorisations.component.html',
  styleUrl: './gestion-autorisations.component.scss'
})
export class GestionAutorisationsComponent {

}
